define([
    "jquery",
    "underscore",
    "marionette",
    "views/common/datatables_view"
], function($, _, Marionette, DatatablesView){
    return Marionette.LayoutView.extend({
        el: '#content_layout',

        ui: {
            'datatables': '#datatables',
            'datatablesUnfundedAccounts': '#datatables_unfunded_accounts',
            'modal': '.modal'
        },

        events:{
            'show.bs.modal @ui.modal': function(e){
                if(!this.datatablesUnfundedAccountsView) {
                    this.datatablesUnfundedAccountsView = new DatatablesView(
                        {
                            datatablesEl: this.ui.datatablesUnfundedAccounts,
                            url: '/rest_client_status/unfunded_accounts',
                            order: [[0, "desc"]],
                            columns: [
                                {
                                    'name': 'name',
                                    'data': 'name'
                                },
                                {
                                    'name': 'reg_datetime',
                                    'data': 'reg_datetime',
                                    'type': 'date'
                                },
                                {
                                    'name': 'country',
                                    'data': 'country'
                                },
                                {
                                    'name': 'email',
                                    'data': 'email'
                                },
                                {
                                    'name': 'phone_number',
                                    'data': 'phone_number'
                                }
                            ]
                        }
                    );
                }
            }
        },

        initialize: function(){
            this.bindUIElements();
            var columns =[
                {
                    'name':'members.mt4_account_no',
                    'data':'mt4_account_no'
                },
                {
                    'name':'name',
                    'data':'name'
                },
                {
                    'name':'reg_datetime',
                    'data':'reg_datetime',
                    'type': 'date'
                },
                {
                    'name':'country',
                    'data':'country'
                },
                {
                    'name':'deposit',
                    'data':'deposit'
                },
                {
                    'name':'withdrawal',
                    'data':'withdrawal'
                },
                {
                    'name':'total_bonus',
                    'data':'total_bonus'
                },
                {
                    'name':'balance',
                    'data':'balance'
                }
            ];

            if((country == 'Japan')
            || ( IbMt4AccountNo >= 6000 && IbMt4AccountNo <= 6999)){
                columns.splice(4, 0, {
                    'name':'type',
                    'data':'type'
                });
            }

            this.datatablesView = new DatatablesView({
                datatablesEl: this.ui.datatables,
                url: '/rest_client_status/traders_status_all',
                order: [[ 0, "desc" ]],
                columns: columns
            });
        }
    });


});
